$(function ()
{
    var catSwitchReversed = $(".category__view-toggle").hasClass("reversed");

    if (sessionStorage.getItem("roomviewActive") !== null)
    {
        if (sessionStorage.getItem("roomviewActive") == "true")
        {
            // standard
            if (!catSwitchReversed)
            {
                $(".switch").click();

                $(".category__view-toggle-productview").removeClass("active-toggle");
                $(".category__view-toggle-roomview").addClass("active-toggle");

                $.each($(".page-category-item .category-item__image"), function(index, item)
                {
                    if ($(item).find(".category-item__image-img").length > 1)
                    {
                        $(item).find(".category-item__image-img-0").addClass("d-none");
                        $(item).find(".category-item__image-img-2").addClass("d-block");
                    }
                });
            }
        }
        else
        {
            if (catSwitchReversed)
            {
                $(".switch").click();

                $(".category__view-toggle-productview").removeClass("active-toggle");
                $(".category__view-toggle-roomview").addClass("active-toggle");

                $.each($(".page-category-item .category-item__image"), function(index, item)
                {
                    if ($(item).find(".category-item__image-img").length > 1)
                    {
                        $(item).find(".category-item__image-img-0").addClass("d-none");
                        $(item).find(".category-item__image-img-2").addClass("d-block");
                    }
                });
            }
        }
    }
    else
    {
        if ($("#roomview-initial").length)
        {
            if ($("#roomview-initial").val() == 1)
            {
                $(".switch").click();

                $(".category__view-toggle-productview").addClass("active-toggle");
                $(".category__view-toggle-roomview").removeClass("active-toggle");

                $.each($(".page-category-item .category-item__image"), function(index, item)
                {
                    if ($(item).find(".category-item__image-img").length > 1)
                    {
                        $(item).find(".category-item__image-img-0").removeClass("d-none");
                        $(item).find(".category-item__image-img-2").removeClass("d-block");
                    }
                });
            }
        }
    }

    $(".category__view-toggle .switch input").change(function()
    {

        if ($(this).prop("checked") == true)
        {

            $(".category__view-toggle-productview").removeClass("active-toggle");
            $(".category__view-toggle-roomview").addClass("active-toggle");

            $.each($(".page-category-item .category-item__image"), function(index, item)
            {
                if ($(item).find(".category-item__image-img").length > 1)
                {
                    $(item).find(".category-item__image-img-0").addClass("d-none");
                    $(item).find(".category-item__image-img-2").addClass("d-block");
                }
            });

        }
        else
        {

            $(".category__view-toggle-productview").addClass("active-toggle");
            $(".category__view-toggle-roomview").removeClass("active-toggle");

            $.each($(".page-category-item .category-item__image"), function(index, item)
            {
                if ($(item).find(".category-item__image-img").length > 1)
                {
                    $(item).find(".category-item__image-img-0").removeClass("d-none");
                    $(item).find(".category-item__image-img-2").removeClass("d-block");
                }
            });

        }

        $(".load-on-hover").each(function(index, item)
        {
            $(item).attr("src", $(item)[0].dataset.src).removeClass("load-on-hover");
        });

        if (catSwitchReversed)
        {
            sessionStorage.setItem("roomviewActive", !$(this).prop("checked"));
        }
        else
        {
            sessionStorage.setItem("roomviewActive", $(this).prop("checked"));
        }

    });
})
